var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('content-card',{attrs:{"content-class":_vm.contentClass},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)},[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }